import { CUSTOM_SUPPLIER_TYPE, INDUSTRY_TYPE } from "@/types/enum/supplierEnum";

const option = {
    industry: {
        [INDUSTRY_TYPE.PRIVATE]: 'Privat',
        [INDUSTRY_TYPE.DRINK]: 'Getränke Fachgroßhandel',
        [INDUSTRY_TYPE.GROCERY]: 'Lebensmittel Großhandel',
        [INDUSTRY_TYPE.GENERAL]: 'Handelswaren allgemein',
        [INDUSTRY_TYPE.OTHER]: 'Sonstige',
    },
    customSupplierType: {
        [CUSTOM_SUPPLIER_TYPE.MEAT]: 'Fleischlieferant',
        [CUSTOM_SUPPLIER_TYPE.VEGETABLE]: 'Gemüse',
        [CUSTOM_SUPPLIER_TYPE.DRINKS]: 'Getränke',
        [CUSTOM_SUPPLIER_TYPE.HYGIENE]: 'Hygieneartikel',
        [CUSTOM_SUPPLIER_TYPE.OTHER]: 'Andere',
    }
}

export default option
